export class GeneralInformationWAReqModel {
    public name: string;
    public accountId: string;
    public type: string;
    public text: string;
    public subject: string;
    public image: {
        url: string;
    };
    public video: {
        url: string;
    };
    public document: {
        url: string;
        fileName: string;
    };
    public template: {
        id?: string;
        name: string;
        lang: string;
        headerUrl?: string;
        header: any;
        data: any[];
        button: any;
        buttonParams: any[];
        carousel?: any[];
    };
    public list: {
        button: string;
        sections: {
            title: string;
            items: {
                id: string;
                title: string;
                description: string;
            }[];
        }[];
    };
    public buttons: {
        type: string;
        id: string;
        title: string;
    }[];

    public category: string;
    public isNeedSave: boolean;
    public ttlSeconds: number;

    public clone(source: any): GeneralInformationWAReqModel {
        if (
            source?.media === 'IMAGE' ||
            source?.media === 'VIDEO' ||
            source?.media === 'DOCUMENT'
        ) {
            source.channel = source.media;
        }

        if (source.campaignName) {
            this.name = source.campaignName;
        }
        if (source.medium === 'EMAIL') {
            this.subject = source.campaignName;
        }
        if (source.from?.id) {
            this.accountId = source.from.id;
        }
        if (source.channel) {
            this.type = source.channel?.toLowerCase();
        }
        if (source.text) {
            this.text = source.text;
        }
        if (this.type === 'image' && source.fileName) {
            this.image = {
                url: source.targetURL,
            };
        }
        if (this.type === 'video' && source.fileName) {
            this.video = {
                url: source.targetURL,
            };
        }
        if (this.type === 'document' && source.fileName) {
            this.document = {
                url: source.targetURL,
                fileName: source.fileName,
            };
        }

        if (source.template) {
            let qrIndex = 0;
            const finalButtons =
                source.paramButton?.reduce((result: any[], each: any, idx: number) => {
                    const btnDef = source.template?.buttons?.[idx];

                    if (btnDef?.type === 'QUICK_REPLY') {
                        const qrParam =
                            source.buttonParams && source.buttonParams[qrIndex]
                                ? source.buttonParams[qrIndex]
                                : null;
                        qrIndex++;
                        result.push(
                            qrParam ? [qrParam.payload ? qrParam.payload : qrParam.label] : []
                        );
                    } else {
                        result.push(each.name?.map((t: any) => t.name) ?? []);
                    }

                    return result;
                }, []) ?? [];

            // CAROUSEL
            let carouselPayload = undefined;
            if (source.paramCarousel && source.paramCarousel.length > 0) {
                carouselPayload = source.paramCarousel.map((card: any) => {
                    const mappedBody = (card.bodyParams || []).map((b: any) => b.paramName || '');
                    const mappedButtons = (card.buttonParams || []).map((btnGroup: any[]) => {
                        return (btnGroup || []).map((btn: any) => {
                            if (btn.payload !== undefined && btn.payload !== null) {
                                return btn.payload;
                            }
                            return btn.paramName || '';
                        });
                    });

                    return {
                        headerURL: card.headerURL || '',
                        body: mappedBody,
                        button: mappedButtons,
                    };
                });
            }

            this.template = {
                id: source.template.ID,
                name: source.template.name,
                lang: source.template.lang,
                headerUrl: source.targetURL,
                header: source.paramHeader?.map((t: any) => t.name) ?? [],
                data:
                    source.isUseExistingTemplate && source.variables?.length
                        ? source.variables.map((v: any) => v.paramName)
                        : (source.paramBody?.map((t: any) => t.name) ?? []),

                button: finalButtons,
                buttonParams: source.buttonParams
                    ? source.buttonParams.map((btn: any) => {
                          return {
                              label: btn.label,
                              payload: btn.payload ? btn.payload : btn.label,
                          };
                      })
                    : [],
                ...(carouselPayload && carouselPayload.length > 0
                    ? { carousel: carouselPayload }
                    : {}),
            };

            if (source.template.category === 'AUTHENTICATION')
                this.template = {
                    name: source.template.name,
                    lang: source.template.lang,
                    header: null,
                    data: [source.otpValue],
                    button: [[source.otpValue]],
                    buttonParams: [],
                };

            if (source.template.ID) this.template.id = source.template.ID;
        }

        if (this.type === 'utility') {
            this.type = 'template';
            this.category = 'utility';

            const mappedVariables = source?.variables?.length
                ? source.variables.map((v: any) => v.paramName)
                : [];

            if (source?.isUseExistingTemplate) {
                this.template = {
                    ...source.template,
                    data: source.isDownloadVariableXLS
                        ? []
                        : mappedVariables.length > 0
                          ? mappedVariables
                          : source.template.data || [],
                };
            } else {
                this.template = {
                    name: '',
                    lang: 'id',
                    header: null,
                    button: null,
                    data: source.isDownloadVariableXLS ? [] : mappedVariables,
                    buttonParams: [],
                };
            }

            this.isNeedSave = source.isNeedSave;
            this.ttlSeconds = source.ttl;

            if (source?.isUseExistingTemplate) {
                this.text = source?.text || source?.template?.body?.text;
            }
        }

        return this;
    }

    public convert(): any {
        return this;
    }
}
